import { User } from "../../../auth/types";
import { httpWebApi } from "../../../../core/http/httpThunks";
import { GuaranteeFilter, PayGroup } from "../types";
import { getParamsDateString } from "../../../../core/util/functions";

export const getGuaranteesExcel = (user: User, filter: GuaranteeFilter) => {
  return httpWebApi<Blob>({
    method: "GET",
    responseType: "blob",
    timeout: 60 * 4 * 1000,
    url: "reporting/getpaymentsxls",
    params: {
      userid: user.userId,
      paygroup: PayGroup.Guarantees,
      inout: filter.inout,
      cliid: filter?.client?.cliId,
      nondedicated: filter.nondedicated,
      datefrom: getParamsDateString(filter.datefrom),
      dateto: getParamsDateString(filter.dateto),
      },
  });
};

export default getGuaranteesExcel;
